import {styled as muiStyled} from '@mui/material'

const ButtonElement = muiStyled('button')({})

export default ButtonElement
